import {Sync} from '@client/sync'
import {User} from 'yougile-model'

export const getUserIdByEmail = (email: string): User | undefined => {
  const box = Sync.getCurrentSandbox()
  return box.getAllUsers(false).find(u => u.email === email)
}
